/**
 * Pull every top-level <svg>...</svg> block out of an assistant message.
 *
 * The schemdraw renderer (`_render_subcircuit`) returns inline SVG markup
 * inside the assistant response. react-markdown escapes raw HTML, so the
 * SVG would otherwise render as literal text. We split the content at SVG
 * boundaries and let `<SchematicSvg>` inject each block as DOM separately.
 *
 * Only matches non-nested top-level <svg ...>...</svg> — the schemdraw
 * output has no nested <svg> elements, so this stays safe.
 */
export interface SvgExtractResult {
  /** Message text with every top-level <svg> block removed. */
  text: string;
  /** One entry per detected SVG, in source order. */
  svgs: string[];
}

const SVG_BLOCK_RE = /<svg\b[^>]*>[\s\S]*?<\/svg>/gi;

export function extractSvg(raw: string): SvgExtractResult {
  if (!raw) return { text: "", svgs: [] };

  const svgs: string[] = [];
  const text = raw
    .replace(SVG_BLOCK_RE, (match) => {
      svgs.push(match);
      return "";
    })
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return { text, svgs };
}
